import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_Tips",
  "use": "icon-ic_Tips-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-ic_Tips\"><defs><style>#icon-ic_Tips .a{fill:rgba(255,255,255,0);}#icon-ic_Tips .b{fill:#f7a200;}</style></defs><path class=\"a\" d=\"M0,0H20V20H0Z\" /><path class=\"b\" d=\"M9.962,0a9.961,9.961,0,1,0,9.961,9.961A9.962,9.962,0,0,0,9.962,0Zm0,15.488a1.105,1.105,0,1,1,1.105-1.105,1.105,1.105,0,0,1-1.105,1.105Zm.552-4.48c0,.612-.254,1.1-.552,1.1s-.553-.493-.553-1.1L8.856,6.094a1.105,1.105,0,1,1,2.21,0l-.553,4.914Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol